import premiumRules from '../../../shared/premium';
const { isPremiumActive, premiumExpiryTime } = premiumRules;

interface PremiumGrant { premium: unknown; premiumExpiry?: unknown }
interface ExpiryClock {
  now(): number;
  schedule(callback: () => void, delay: number): () => void;
}
const systemClock: ExpiryClock = {
  now: () => Date.now(),
  schedule(callback, delay) { const id = setTimeout(callback, delay); return () => clearTimeout(id); },
};

/** One cancellable observer; wakes correctly after a sleeping or backgrounded tab. */
export function observePremiumExpiration(grant: PremiumGrant | null, expired: () => void, options: { clock?: ExpiryClock; wakeTargets?: EventTarget[] } = {}) {
  if (!grant?.premium) return () => {};
  const clock = options.clock ?? systemClock;
  const targets = options.wakeTargets ?? (typeof window === 'undefined' ? [] : [window, document]);
  let stopped = false;
  let cancelTimer: (() => void) | undefined;
  const cleanup = () => {
    stopped = true;
    cancelTimer?.();
    for (const target of targets) { target.removeEventListener('focus', check); target.removeEventListener('visibilitychange', check); }
  };
  const check = () => {
    if (stopped) return;
    cancelTimer?.(); cancelTimer = undefined;
    if (!isPremiumActive(grant.premium, grant.premiumExpiry, clock.now())) { cleanup(); expired(); return; }
    const until = premiumExpiryTime(grant.premiumExpiry);
    if (until !== null) cancelTimer = clock.schedule(check, Math.min(2147483647, Math.max(0, until - clock.now())));
  };
  for (const target of targets) { target.addEventListener('focus', check); target.addEventListener('visibilitychange', check); }
  check();
  return cleanup;
}
